import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import axios from "axios";
import Swal from "sweetalert2";

import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";
import comprueboPermisos from "../tools/comprueboPermisos";
import socket from "../tools/socke";

import ModalSancion from "./Modal";
import Sancion from "./Sancion";

// IMPORTANTE:
// reutilizamos exactamente el CSS del módulo principal.
import "./Sancionaa.css";

const ObtieneSancionesANotificar = ({ refresca }) => {
  const Usuario = ObtieneDatosCookies();

  // ============================================================
  // ESTADOS
  // ============================================================

  const [
    listadoSanciones,
    setListadoSanciones,
  ] = useState([]);

  const [cargando, setCargando] =
    useState(false);

  const [
    sancionSeleccionada,
    setSancionSeleccionada,
  ] = useState(null);

  const [
    veoDatosSancion,
    setVeoDatosSancion,
  ] = useState(false);

  const [error, setError] =
    useState("");

  // ============================================================
  // TOKEN
  // ============================================================

  const obtenerToken = () => {
    const username =
      process.env.REACT_APP_KEY;

    const password =
      process.env.REACT_APP_PASS;

    return btoa(
      `${username}:${password}`
    );
  };

  // ============================================================
  // OBTENER SANCIONES
  // ============================================================

  const obtieneSancionesANotificar =
    useCallback(async () => {
      if (!Usuario?.id) {
        return;
      }

      try {
        setCargando(true);
        setError("");

        let sede = null;

        if (
          comprueboPermisos(
            Usuario?.funcion,
            "Cuerpo"
          )
        ) {
          sede =
            Number(Usuario?.sedeID) === 2
              ? "Rosario"
              : "Recreo";
        }

        const response =
          await axios.post(
            "https://wwwa.isepsantafe.net.ar/expedientes/Ncadetes/devuelveSancionesANotificar/",
            {
              sede,
            }
          );

        setListadoSanciones(
          Array.isArray(response?.data)
            ? response.data
            : []
        );
      } catch (error) {
        console.error(
          "Error obteniendo sanciones a notificar:",
          error
        );

        setListadoSanciones([]);

        setError(
          "No se pudieron obtener las sanciones pendientes de notificación."
        );
      } finally {
        setCargando(false);
      }
    }, [
      Usuario?.id,
      Usuario?.funcion,
      Usuario?.sedeID,
    ]);

  // ============================================================
  // ANULAR SANCION
  // ============================================================

  const anulaSancion = async (
    sancion
  ) => {
    try {
      const token = obtenerToken();

      const response =
        await axios.post(
          `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/actualizaSancion/${sancion.id}`,
          {
            estado: "Anulada",
          },
          {
            headers: {
              Authorization:
                `Basic ${token}`,
            },
          }
        );

      if (response?.data?.success) {
        await Swal.fire({
          title: "Sanción anulada",
          text: `Se anuló la sanción correspondiente al cadete DNI ${sancion.cadeteDni}.`,
          icon: "success",
          confirmButtonText:
            "Aceptar",
        });

        setSancionSeleccionada(
          null
        );

        setVeoDatosSancion(false);

        socket.emit(
          "sancionEvent",
          ""
        );

        obtieneSancionesANotificar();

        return;
      }

      Swal.fire({
        title: "No se pudo anular",
        text:
          response?.data?.message ||
          "Compruebe los datos e intente nuevamente.",
        icon: "error",
        confirmButtonText:
          "Aceptar",
      });
    } catch (error) {
      console.error(
        "Error anulando sanción:",
        error
      );

      Swal.fire({
        title: "Error",
        text:
          "No se pudo anular la sanción.",
        icon: "error",
        confirmButtonText:
          "Aceptar",
      });
    }
  };

  // ============================================================
  // NOTIFICAR
  // ============================================================

  const notificarSancion = async (
    sancion
  ) => {
    try {
      const token = obtenerToken();

      const response =
        await axios.post(
          `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/actualizaSancion/${sancion.id}`,
          {
            fechaNotificado:
              new Date(),
          },
          {
            headers: {
              Authorization:
                `Basic ${token}`,
            },
          }
        );

      if (response?.data?.success) {
        await Swal.fire({
          title:
            "Sanción notificada",
          text: `Se notificó correctamente la sanción al cadete DNI ${sancion.cadeteDni}.`,
          icon: "success",
          confirmButtonText:
            "Aceptar",
        });

        socket.emit(
          "sancionEvent",
          sancion.cadeteDni
        );

        obtieneSancionesANotificar();

        return;
      }

      Swal.fire({
        title:
          response?.data?.message ||
          "No se pudo notificar",
        text:
          "Compruebe los datos e intente nuevamente.",
        icon: "error",
        confirmButtonText:
          "Aceptar",
      });
    } catch (error) {
      console.error(
        "Error notificando sanción:",
        error
      );

      Swal.fire({
        title: "Error",
        text:
          "No se pudo registrar la notificación.",
        icon: "error",
        confirmButtonText:
          "Aceptar",
      });
    }
  };

  // ============================================================
  // PASAR A CONFIRMACION
  // ============================================================

  const pasaAConfirmarSancion =
    async (sancion) => {
      try {
        const token =
          obtenerToken();

        const response =
          await axios.post(
            `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/actualizaSancion/${sancion.id}`,
            {
              estado:
                "Para Confirmar",
            },
            {
              headers: {
                Authorization:
                  `Basic ${token}`,
              },
            }
          );

        if (
          response?.data?.success
        ) {
          await Swal.fire({
            title:
              "Sanción enviada a confirmar",
            text: `La sanción del cadete DNI ${sancion.cadeteDni} quedó pendiente de confirmación por la superioridad.`,
            icon: "success",
            confirmButtonText:
              "Aceptar",
          });

          socket.emit(
            "sancionEvent",
            sancion.cadeteDni
          );

          obtieneSancionesANotificar();

          return;
        }

        Swal.fire({
          title:
            response?.data?.message ||
            "No se pudo actualizar",
          text:
            "Compruebe los datos e intente nuevamente.",
          icon: "error",
          confirmButtonText:
            "Aceptar",
        });
      } catch (error) {
        console.error(
          "Error pasando sanción a confirmar:",
          error
        );

        Swal.fire({
          title: "Error",
          text:
            "No se pudo modificar el estado de la sanción.",
          icon: "error",
          confirmButtonText:
            "Aceptar",
        });
      }
    };

  // ============================================================
  // ELIMINAR
  // ============================================================

  const eliminaSancion = async (
    sancion
  ) => {
    try {
      const resultado =
        await Swal.fire({
          title:
            "¿Eliminar sanción?",
          text:
            "Esta operación eliminará definitivamente el registro.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText:
            "Eliminar",
          cancelButtonText:
            "Cancelar",
          confirmButtonColor:
            "#b42318",
        });

      if (
        !resultado.isConfirmed
      ) {
        return;
      }

      const token = obtenerToken();

      const response =
        await axios.post(
          `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/eliminaSancion/${sancion.id}`,
          {},
          {
            headers: {
              Authorization:
                `Basic ${token}`,
            },
          }
        );

      if (response?.data?.success) {
        setSancionSeleccionada(
          null
        );

        setVeoDatosSancion(false);

        await Swal.fire({
          title:
            "Sanción eliminada",
          text: `Se eliminó la sanción correspondiente al cadete DNI ${sancion.cadeteDni}.`,
          icon: "success",
          confirmButtonText:
            "Aceptar",
        });

        socket.emit(
          "sancionEvent",
          sancion.cadeteDni
        );

        obtieneSancionesANotificar();

        return;
      }

      Swal.fire({
        title:
          response?.data?.message ||
          "No se pudo eliminar",
        text:
          "Compruebe los datos e intente nuevamente.",
        icon: "error",
        confirmButtonText:
          "Aceptar",
      });
    } catch (error) {
      console.error(
        "Error eliminando sanción:",
        error
      );

      Swal.fire({
        title: "Error",
        text:
          "No se pudo eliminar la sanción.",
        icon: "error",
        confirmButtonText:
          "Aceptar",
      });
    }
  };

  // ============================================================
  // SOCKET
  // ============================================================

  useEffect(() => {
    obtieneSancionesANotificar();

    const handleActualizacion =
      () => {
        obtieneSancionesANotificar();
      };

    socket.on(
      "estadoActualizable",
      handleActualizacion
    );

    return () => {
      socket.off(
        "estadoActualizable",
        handleActualizacion
      );
    };
  }, [
    refresca,
    obtieneSancionesANotificar,
  ]);

  // ============================================================
  // CATEGORIAS
  // ============================================================

  const categorias = useMemo(
    () => {
      return listadoSanciones.reduce(
        (acc, sancion) => {
          const estado =
            sancion?.estado ||
            "Sin estado";

          if (!acc[estado]) {
            acc[estado] = [];
          }

          acc[estado].push(
            sancion
          );

          return acc;
        },
        {}
      );
    },
    [listadoSanciones]
  );

  // ============================================================
  // MOSTRAR DETALLE
  // ============================================================

  const manejoQueVeo = (
    sancion
  ) => {
    setSancionSeleccionada(
      sancion
    );

    setVeoDatosSancion(true);
  };

  // ============================================================
  // HELPERS
  // ============================================================

  const nombreCompleto = (
    sancion
  ) => {
    const apellido =
      sancion?.cadete
        ?.cadeteApellido || "";

    const nombre =
      sancion?.cadete
        ?.cadeteNombre || "";

    return `${apellido} ${nombre}`.trim();
  };

  const obtenerUbicacion = (
    sancion
  ) => {
    const compania =
      sancion?.cadete?.Seccion
        ?.Compania?.nombre;

    const seccion =
      sancion?.cadete?.Seccion
        ?.nombre;

    return [
      compania,
      seccion,
    ]
      .filter(Boolean)
      .join(" · ");
  };

  const obtenerPromocion = (
    sancion
  ) => {
    return (
      sancion?.cadete
        ?.Promocions?.[0]
        ?.nombre || null
    );
  };

  const formatearFecha = (
    fecha
  ) => {
    if (!fecha) {
      return "-";
    }

    const partes =
      String(fecha).split("-");

    if (partes.length === 3) {
      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    }

    return fecha;
  };

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <>
      {/* ====================================================== */}
      {/* MODAL DETALLE */}
      {/* ====================================================== */}

      {veoDatosSancion &&
        sancionSeleccionada && (
          <ModalSancion
            isOpen={
              veoDatosSancion
            }
            onClose={() => {
              setVeoDatosSancion(
                false
              );

              setSancionSeleccionada(
                null
              );
            }}
          >
            <div className="san-v2-modal">

              <div className="san-v2-modal-header">
                <span className="san-v2-modal-eyebrow">
                  ACTUACIÓN DISCIPLINARIA
                </span>

                <h3>
                  Detalle de la sanción
                </h3>

                <p>
                  Información completa de la
                  actuación disciplinaria
                  seleccionada.
                </p>
              </div>

              <div className="san-v2-selected-person">

                <div className="san-v2-avatar">
                  {sancionSeleccionada
                    ?.cadete
                    ?.cadeteApellido
                    ?.charAt(0)
                    ?.toUpperCase() ||
                    "C"}
                </div>

                <div className="san-v2-selected-info">

                  <span>
                    CADETE
                  </span>

                  <strong>
                    {nombreCompleto(
                      sancionSeleccionada
                    ) ||
                      `DNI ${sancionSeleccionada.cadeteDni}`}
                  </strong>

                  <small>
                    DNI{" "}
                    {
                      sancionSeleccionada.cadeteDni
                    }
                  </small>

                </div>
              </div>

              <div className="san-v2-form-container">
                <Sancion
                  sancionPasada={
                    sancionSeleccionada
                  }
                />
              </div>

            </div>
          </ModalSancion>
        )}

      {/* ====================================================== */}
      {/* CONTENIDO */}
      {/* ====================================================== */}

      <div style={{ width: "100%" }}>

        {/* ==================================================== */}
        {/* MINI RESUMEN */}
        {/* ==================================================== */}

        <div className="san-v2-summary">

          <div className="san-v2-stat-card">

            <div className="san-v2-stat-icon san-v2-stat-icon-warning">
              🔔
            </div>

            <div>
              <span>
                Pendientes
              </span>

              <strong>
                {cargando
                  ? "..."
                  : listadoSanciones.length}
              </strong>

              <small>
                Sanciones a notificar
              </small>
            </div>

          </div>

        </div>

        {/* ==================================================== */}
        {/* ERROR */}
        {/* ==================================================== */}

        {error && (
          <div
            className="san-v2-section"
            style={{
              borderColor:
                "#fecdca",
            }}
          >
            <div
              className="san-v2-section-content"
              style={{
                color:
                  "#b42318",
                padding: "14px",
              }}
            >
              {error}
            </div>
          </div>
        )}

        {/* ==================================================== */}
        {/* CARGANDO */}
        {/* ==================================================== */}

        {cargando && (
          <div
            className="san-v2-section"
          >
            <div
              className="san-v2-section-content"
              style={{
                padding:
                  "30px",
                textAlign:
                  "center",
                color:
                  "#667085",
              }}
            >
              Obteniendo sanciones...
            </div>
          </div>
        )}

        {/* ==================================================== */}
        {/* VACIO */}
        {/* ==================================================== */}

        {!cargando &&
          listadoSanciones.length ===
            0 && (
            <div className="san-v2-section">

              <div
                className="san-v2-section-content"
                style={{
                  padding:
                    "35px 20px",
                  textAlign:
                    "center",
                }}
              >
                <div
                  className="san-v2-stat-icon san-v2-stat-icon-confirm"
                  style={{
                    margin:
                      "0 auto 10px",
                  }}
                >
                  ✓
                </div>

                <strong
                  style={{
                    display:
                      "block",
                    color:
                      "#344054",
                    fontSize:
                      "13px",
                  }}
                >
                  Sin sanciones pendientes
                </strong>

                <span
                  style={{
                    display:
                      "block",
                    marginTop:
                      "4px",
                    color:
                      "#98a2b3",
                    fontSize:
                      "11px",
                  }}
                >
                  No existen sanciones pendientes
                  de notificación.
                </span>

              </div>
            </div>
          )}

        {/* ==================================================== */}
        {/* CATEGORIAS */}
        {/* ==================================================== */}

        {!cargando &&
          Object.entries(
            categorias
          ).map(
            ([
              estado,
              sanciones,
            ]) => (
              <section
                className="san-v2-section"
                key={estado}
              >

                {/* ========================================== */}
                {/* HEADER ESTADO */}
                {/* ========================================== */}

                <div className="san-v2-section-header">

                  <div className="san-v2-section-title-group">

                    <div className="san-v2-indicator san-v2-indicator-red" />

                    <div>
                      <h2>
                        {estado}
                      </h2>

                      <p>
                        {
                          sanciones.length
                        }{" "}
                        {sanciones.length ===
                        1
                          ? "sanción"
                          : "sanciones"}{" "}
                        en este estado.
                      </p>
                    </div>

                  </div>

                  <span className="san-v2-section-badge san-v2-badge-red">
                    {
                      sanciones.length
                    }
                  </span>

                </div>

                {/* ========================================== */}
                {/* LISTADO */}
                {/* ========================================== */}

                <div className="san-v2-section-content">

                  {sanciones.map(
                    (
                      sancion,
                      index
                    ) => {
                      const ubicacion =
                        obtenerUbicacion(
                          sancion
                        );

                      const promocion =
                        obtenerPromocion(
                          sancion
                        );

                      return (
                        <div
                          key={
                            sancion.id ||
                            index
                          }
                          className="san-v2-selected-person"
                          style={{
                            margin:
                              "6px",
                            background:
                              "#ffffff",
                            cursor:
                              "pointer",
                          }}
                          onClick={() =>
                            manejoQueVeo(
                              sancion
                            )
                          }
                        >

                          {/* ================================== */}
                          {/* NUMERO */}
                          {/* ================================== */}

                          <div className="san-v2-avatar">
                            {index +
                              1}
                          </div>

                          {/* ================================== */}
                          {/* DATOS */}
                          {/* ================================== */}

                          <div className="san-v2-selected-info">

                            <span>
                              SANCIÓN #
                              {sancion.id ||
                                "-"}
                            </span>

                            <strong>
                              {nombreCompleto(
                                sancion
                              ) ||
                                `DNI ${sancion.cadeteDni}`}
                            </strong>

                            <small>
                              DNI{" "}
                              {
                                sancion.cadeteDni
                              }
                              {" · "}
                              Fecha:{" "}
                              {formatearFecha(
                                sancion.fechaFaltaCometida
                              )}

                              {ubicacion
                                ? ` · ${ubicacion}`
                                : ""}

                              {promocion
                                ? ` · Promoción: ${promocion}`
                                : ""}
                            </small>

                          </div>

                          {/* ================================== */}
                          {/* ESTADO NOTIFICACION */}
                          {/* ================================== */}

                          {sancion.fechaNotificado ? (
                            <span className="san-v2-section-badge san-v2-badge-green">
                              ✓ Notificado
                            </span>
                          ) : sancion.estado ===
                            "Activa" ? (
                            <span className="san-v2-section-badge san-v2-badge-warning">
                              Esperando al cadete
                            </span>
                          ) : (
                            <span className="san-v2-section-badge">
                              {
                                sancion.estado
                              }
                            </span>
                          )}

                        </div>
                      );
                    }
                  )}

                </div>

              </section>
            )
          )}
      </div>
    </>
  );
};

export default ObtieneSancionesANotificar;